/**
 * The PathShortcuts are intended to make it easier to write the path to a
 * component in the JSP file. They must match with the beginning of the
 * data-component attribute.
 */
const PathShortcuts: Record<string, string> = {
  execution: 'apia/execution',
  '@': 'apia/query/',
  '&': 'apia/administration/',
  admin: 'apia/administration',
  '!': 'apia/login/',
  '-': 'apia/monitor/',
  control: 'apia/control',
  design: 'apia/design',
  main: 'apia/main',
  apiaCommon: 'apia/common',
  tasklist: 'apia/tasklist',
  monitor: 'apia/monitor',
};

export default PathShortcuts;
